<template>
    <div class="room gas-clamp">
        <RefreshBlock @refreshData="refreshData"></RefreshBlock>
        <div class="main-cable" v-loading="loading">
            <div class="cable-title">
                <h2>南侧进气</h2>
            </div>
            <div class="cable-main">
                <div class="legend">
                    <div class="sensor1">排气口</div>
                    <div class="sensor2">进气口</div>
                </div>
                <div class="legend-station">
                    <i class="iconfont iconshebei"></i>
                    <span>除湿机</span>
                </div>
                <div class="legend-right">
                    <div class="running">设备运行</div>
                    <div class="stopped">设备停止</div>
                    <div class="default">数据中断</div>
                </div>
                <div class="dir left-dir">
                    <i class="iconfont icongeo-arrow-left"></i>
                    <span class="dir-text">镇宁(东)</span>
                </div>
                <div class="dir right-dir">
                    <i class="iconfont icongeo-arrow-left-copy"></i>
                    <span class="dir-text">胜境关(西)</span>
                </div>
                <div class="cable-img">
                    <div class="clip sensor1 sensor-left-1">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorSES0, humidityAllowedMaxSES0) }}
                            </div>
                            <div :class="errorSES0" class="state-info right-pos" @dblclick="hrefToScenario('')">
                                <p>SES0传感器</p>
                                <p>
                                    <span>{{ humiditySES0 | toFixed }}% {{ temperatureSES0 | toFixed }}°C</span>
                                    <br /><span>{{ pressureSES0 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor2 sensor-left-2">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorSES1, humidityAllowedMaxSES1) }}
                            </div>
                            <div :class="errorSES1" class="state-info top-right-pos-1" @dblclick="hrefToScenario('')">
                                <p>SES1传感器</p>
                                <p>
                                    <span>{{ humiditySES1 | toFixed }}% {{ temperatureSES1 | toFixed }}°C</span>
                                    <br /><span>{{ pressureSES1 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-left-3">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorSES2, humidityAllowedMaxSES2) }}
                            </div>
                            <div :class="errorSES2" class="state-info right-pos" @dblclick="hrefToScenario('')">
                                <p>SES2传感器</p>
                                <p>
                                    <span>{{ humiditySES2 | toFixed }}% {{ temperatureSES2 | toFixed }}°C</span>
                                    <br /><span>{{ pressureSES2 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-left-1">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMES2, humidityAllowedMaxMES2) }}
                            </div>
                            <div :class="errorMES2" class="state-info left-pos" @dblclick="hrefToScenario('')">
                                <p>MES2传感器</p>
                                <p>
                                    <span>{{ humidityMES2 | toFixed }}% {{ temperatureMES2 | toFixed }}°C</span>
                                    <br /><span>{{ pressureMES2 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-left-2">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMES1, humidityAllowedMaxMES1) }}
                            </div>
                            <div :class="errorMES1" class="state-info top-right-pos-1" @dblclick="hrefToScenario('')">
                                <p>MES1传感器</p>
                                <p>
                                    <span>{{ humidityMES1 | toFixed }}% {{ temperatureMES1 | toFixed }}°C</span>
                                    <br /><span>{{ pressureMES1 | toFixed }}%</span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-left-3">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMESPlus, humidityAllowedMaxMESPlus) }}
                            </div>
                            <div :class="errorMESPlus" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                                <p>MES+传感器</p>
                                <p>
                                    <span>{{ humidityMESPlus | toFixed }}% {{ temperatureMESPlus | toFixed }}°C</span>
                                    <br /><span>{{ pressureMESPlus | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-up">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMES0, humidityAllowedMaxMES0) }}
                            </div>
                            <div :class="errorMES0" class="state-info bottom-left-pos-mid"
                                @dblclick="hrefToScenario('')">
                                <p>MES0传感器</p>
                                <p>
                                    <span>{{ humidityMES0 | toFixed }}% {{ temperatureMES0 | toFixed }}°C</span>
                                    <br /><span>{{ pressureMES0 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-down">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMWS0, humidityAllowedMaxMWS0) }}
                            </div>
                            <div :class="errorMWS0" class="state-info top-right-pos-mid" @dblclick="hrefToScenario('')">
                                <p>MWS0传感器</p>
                                <p>
                                    <span>{{ humidityMWS0 | toFixed }}% {{ temperatureMWS0 | toFixed }}°C</span>
                                    <br /><span>{{ pressureMWS0 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-right-3">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMWSPlus, humidityAllowedMaxMWSPlus) }}
                            </div>
                            <div :class="errorMWSPlus" class="state-info bottom-pos" @dblclick="hrefToScenario('')">
                                <p>MWS+传感器</p>
                                <p>
                                    <span>{{ humidityMWSPlus | toFixed }}% {{ temperatureMWSPlus | toFixed }}°C</span>
                                    <br /><span>{{ pressureMWSPlus | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-right-2">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMWS1, humidityAllowedMaxMWS1) }}
                            </div>
                            <div :class="errorMWS1" class="state-info top-left-pos-1" @dblclick="hrefToScenario('')">
                                <p>MWS1传感器</p>
                                <p>
                                    <span>{{ humidityMWS1 | toFixed }}% {{ temperatureMWS1 | toFixed }}°C</span>
                                    <br /><span>{{ pressureMWS1 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-right-1">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMWS2, humidityAllowedMaxMWS2) }}
                            </div>
                            <div :class="errorMWS2" class="state-info right-pos" @dblclick="hrefToScenario('')">
                                <p>MWS2传感器</p>
                                <p>
                                    <span>{{ humidityMWS2 | toFixed }}% {{ temperatureMWS2 | toFixed }}°C</span>
                                    <br /><span>{{ pressureMWS2 | toFixed }}%</span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-right-3">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorSWS2, humidityAllowedMaxSWS2) }}
                            </div>
                            <div :class="errorSWS2" class="state-info left-pos" @dblclick="hrefToScenario('')">
                                <p>SWS2传感器</p>
                                <p>
                                    <span>{{ humiditySWS2 | toFixed }}% {{ temperatureSWS2 | toFixed }}°C</span>
                                    <br /><span>{{ pressureSWS2 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-right-2">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorSWS1, humidityAllowedMaxSWS1) }}
                            </div>
                            <div :class="errorSWS1" class="state-info top-left-pos-1" @dblclick="hrefToScenario('')">
                                <p>SWS1传感器</p>
                                <p>
                                    <span>{{ humiditySWS1 | toFixed }}% {{ temperatureSWS1 | toFixed }}°C</span>
                                    <br /><span>{{ pressureSWS1 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-right-1">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorSWS0, humidityAllowedMaxSWS0) }}
                            </div>
                            <div :class="errorSWS0" class="state-info left-pos" @dblclick="hrefToScenario('')">
                                <p>SWS0传感器</p>
                                <p>
                                    <span>{{ humiditySWS0 | toFixed }}% {{ temperatureSWS0 | toFixed }}°C</span>
                                    <br /><span>{{ pressureSWS0 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-cable" v-loading="loading">
            <div class="cable-title">
                <h2>南侧排气</h2>
            </div>
            <div class="cable-main">
                <div class="legend">
                    <div class="sensor1">排气口</div>
                    <div class="sensor2">进气口</div>
                </div>
                <div class="legend-station">
                    <i class="iconfont iconshebei"></i>
                    <span>除湿机</span>
                </div>
                <div class="legend-right">
                    <div class="running">设备运行</div>
                    <div class="stopped">设备停止</div>
                    <div class="default">数据中断</div>
                </div>
                <div class="dir left-dir">
                    <i class="iconfont icongeo-arrow-left"></i>
                    <span class="dir-text">镇宁(东)</span>
                </div>
                <div class="dir right-dir">
                    <i class="iconfont icongeo-arrow-left-copy"></i>
                    <span class="dir-text">胜境关(西)</span>
                </div>
                <div class="cable-img">

                    <div class="clip sensor1 sensor-left-1">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorSEN0, humidityAllowedMaxSEN0) }}
                            </div>
                            <div :class="errorSEN0" class="state-info right-pos" @dblclick="hrefToScenario('')">
                                <p>SEN0传感器</p>
                                <p>
                                    <span>{{ humiditySEN0 | toFixed }}% {{ temperatureSEN0 | toFixed }}°C</span>
                                    <br /><span>{{ pressureSEN0 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-left-2">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorSEN1, humidityAllowedMaxSEN1) }}
                            </div>
                            <div :class="errorSEN1" class="state-info top-right-pos-1" @dblclick="hrefToScenario('')">
                                <p>SEN1传感器</p>
                                <p>
                                    <span>{{ humiditySEN1 | toFixed }}% {{ temperatureSEN1 | toFixed }}°C</span>
                                    <br /><span>{{ pressureSEN1 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-left-3">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorSEN2, humidityAllowedMaxSEN2) }}
                            </div>
                            <div :class="errorSEN2" class="state-info right-pos" @dblclick="hrefToScenario('')">
                                <p>SEN2传感器</p>
                                <p>
                                    <span>{{ humiditySEN2 | toFixed }}% {{ temperatureSEN2 | toFixed }}°C</span>
                                    <br /><span>{{ pressureSEN2 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-left-1-no-plus">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMEN2, humidityAllowedMaxMEN2) }}
                            </div>
                            <div :class="errorMEN2" class="state-info left-pos" @dblclick="hrefToScenario('')">
                                <p>MEN2传感器</p>
                                <p>
                                    <span>{{ humidityMEN2 | toFixed }}% {{ temperatureMEN2 | toFixed }}°C</span>
                                    <br /><span>{{ pressureMEN2 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-left-2">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMEN1, humidityAllowedMaxMEN1) }}
                            </div>
                            <div :class="errorMEN1" class="state-info top-right-pos-1" @dblclick="hrefToScenario('')">
                                <p>MEN1传感器</p>
                                <p>
                                    <span>{{ humidityMEN1 | toFixed }}% {{ temperatureMEN1 | toFixed }}°C</span>
                                    <br /><span>{{ pressureMEN1 | toFixed }}%</span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-up-no-plus">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMEN0, humidityAllowedMaxMEN0) }}
                            </div>
                            <div :class="errorMEN0" class="state-info bottom-left-pos-mid"
                                @dblclick="hrefToScenario('')">
                                <p>MEN0传感器</p>
                                <p>
                                    <span>{{ humidityMEN0 | toFixed }}% {{ temperatureMEN0 | toFixed }}°C</span>
                                    <br /><span>{{ pressureMEN0 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-down">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMWN0, humidityAllowedMaxMWN0) }}
                            </div>
                            <div :class="errorMWN0" class="state-info top-right-pos-mid" @dblclick="hrefToScenario('')">
                                <p>MWN0传感器</p>
                                <p>
                                    <span>{{ humidityMWN0 | toFixed }}% {{ temperatureMWN0 | toFixed }}°C</span>
                                    <br /><span>{{ pressureMWN0 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-right-2">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMWN1, humidityAllowedMaxMWN1) }}
                            </div>
                            <div :class="errorMWN1" class="state-info top-left-pos-1" @dblclick="hrefToScenario('')">
                                <p>MWN1传感器</p>
                                <p>
                                    <span>{{ humidityMWN1 | toFixed }}% {{ temperatureMWN1 | toFixed }}°C</span>
                                    <br /><span>{{ pressureMWN1 | toFixed }}%</span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-middle-right-1-no-plus">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorMWN2, humidityAllowedMaxMWN2) }}
                            </div>
                            <div :class="errorMWN2" class="state-info right-pos" @dblclick="hrefToScenario('')">
                                <p>MWN2传感器</p>
                                <p>
                                    <span>{{ humidityMWN2 | toFixed }}% {{ temperatureMWN2 | toFixed }}°C</span>
                                    <br /><span>{{ pressureMWN2 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>


                    <div class="clip sensor1 sensor-right-3">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorSWN2, humidityAllowedMaxSWN2) }}
                            </div>
                            <div :class="errorSWN2" class="state-info left-pos" @dblclick="hrefToScenario('')">
                                <p>SWN2传感器</p>
                                <p>
                                    <span>{{ humiditySWN2 | toFixed }}% {{ temperatureSWN2 | toFixed }}°C</span>
                                    <br /><span>{{ pressureSWN2 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-right-2">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorSWN1, humidityAllowedMaxSWN1) }}
                            </div>
                            <div :class="errorSWN1" class="state-info top-left-pos-1" @dblclick="hrefToScenario('')">
                                <p>SWN1传感器</p>
                                <p>
                                    <span>{{ humiditySWN1 | toFixed }}% {{ temperatureSWN1 | toFixed }}°C</span>
                                    <br /><span>{{ pressureSWN1 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>

                    <div class="clip sensor1 sensor-right-1">
                        <el-tooltip effect="light" placement="bottom">
                            <div slot="content" class="tooltip-slot">
                                {{ assembleTooltip_sensor("", humidityTooltipErrorSWN0, humidityAllowedMaxSWN0) }}
                            </div>
                            <div :class="errorSWN0" class="state-info left-pos" @dblclick="hrefToScenario('')">
                                <p>SWN0传感器</p>
                                <p>
                                    <span>{{ humiditySWN0 | toFixed }}% {{ temperatureSWN0 | toFixed }}°C</span>
                                    <br /><span>{{ pressureSWN0 | toFixed }}% </span>
                                </p>
                            </div>
                        </el-tooltip>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "gasClamp",
    data() {
        return {
            loading: true,
            timer: null,

            //humidity, temperature, pressure, flow, volume
            humiditySES0: "--",
            humiditySES1: "--",
            humiditySES2: "--",
            humidityMES2: "--",
            humidityMES1: "--",
            humidityMESPlus: "--",
            humidityMES0: "--",
            humidityMWS0: "--",
            humidityMWSPlus: "--",
            humidityMWS1: "--",
            humidityMWS2: "--",
            humiditySWS2: "--",
            humiditySWS1: "--",
            humiditySWS0: "--",
            humiditySEN0: "--",
            humiditySEN1: "--",
            humiditySEN2: "--",
            humidityMEN2: "--",
            humidityMEN1: "--",
            humidityMEN0: "--",
            humidityMWN0: "--",
            humidityMWN1: "--",
            humidityMWN2: "--",
            humiditySWN2: "--",
            humiditySWN1: "--",
            humiditySWN0: "--",

            temperatureSES0: "--",
            temperatureSES1: "--",
            temperatureSES2: "--",
            temperatureMES2: "--",
            temperatureMES1: "--",
            temperatureMESPlus: "--",
            temperatureMES0: "--",
            temperatureMWS0: "--",
            temperatureMWSPlus: "--",
            temperatureMWS1: "--",
            temperatureMWS2: "--",
            temperatureSWS2: "--",
            temperatureSWS1: "--",
            temperatureSWS0: "--",
            temperatureSEN0: "--",
            temperatureSEN1: "--",
            temperatureSEN2: "--",
            temperatureMEN2: "--",
            temperatureMEN1: "--",
            temperatureMEN0: "--",
            temperatureMWN0: "--",
            temperatureMWN1: "--",
            temperatureMWN2: "--",
            temperatureSWN2: "--",
            temperatureSWN1: "--",
            temperatureSWN0: "--",

            pressureSES0: "--",
            pressureSES1: "--",
            pressureSES2: "--",
            pressureMES2: "--",
            pressureMES1: "--",
            pressureMESPlus: "--",
            pressureMES0: "--",
            pressureMWS0: "--",
            pressureMWSPlus: "--",
            pressureMWS1: "--",
            pressureMWS2: "--",
            pressureSWS2: "--",
            pressureSWS1: "--",
            pressureSWS0: "--",
            pressureSEN0: "--",
            pressureSEN1: "--",
            pressureSEN2: "--",
            pressureMEN2: "--",
            pressureMEN1: "--",
            pressureMEN0: "--",
            pressureMWN0: "--",
            pressureMWN1: "--",
            pressureMWN2: "--",
            pressureSWN2: "--",
            pressureSWN1: "--",
            pressureSWN0: "--",

            //running


            //malfunction


            //error
            errorSES0: "--",
            errorSES1: "--",
            errorSES2: "--",
            errorMES2: "--",
            errorMES1: "--",
            errorMESPlus: "--",
            errorMES0: "--",
            errorMWS0: "--",
            errorMWSPlus: "--",
            errorMWS1: "--",
            errorMWS2: "--",
            errorSWS2: "--",
            errorSWS1: "--",
            errorSWS0: "--",
            errorSEN0: "--",
            errorSEN1: "--",
            errorSEN2: "--",
            errorMEN2: "--",
            errorMEN1: "--",
            errorMEN0: "--",
            errorMWN0: "--",
            errorMWN1: "--",
            errorMWN2: "--",
            errorSWN2: "--",
            errorSWN1: "--",
            errorSWN0: "--",

            //running class

            //humidity allowed max
            humidityAllowedMaxSES0: "--",
            humidityAllowedMaxSES1: "--",
            humidityAllowedMaxSES2: "--",
            humidityAllowedMaxMES2: "--",
            humidityAllowedMaxMES1: "--",
            humidityAllowedMaxMESPlus: "--",
            humidityAllowedMaxMES0: "--",
            humidityAllowedMaxMWS0: "--",
            humidityAllowedMaxMWSPlus: "--",
            humidityAllowedMaxMWS1: "--",
            humidityAllowedMaxMWS2: "--",
            humidityAllowedMaxSWS2: "--",
            humidityAllowedMaxSWS1: "--",
            humidityAllowedMaxSWS0: "--",
            humidityAllowedMaxSEN0: "--",
            humidityAllowedMaxSEN1: "--",
            humidityAllowedMaxSEN2: "--",
            humidityAllowedMaxMEN2: "--",
            humidityAllowedMaxMEN1: "--",
            humidityAllowedMaxMEN0: "--",
            humidityAllowedMaxMWN0: "--",
            humidityAllowedMaxMWN1: "--",
            humidityAllowedMaxMWN2: "--",
            humidityAllowedMaxSWN2: "--",
            humidityAllowedMaxSWN1: "--",
            humidityAllowedMaxSWN0: "--",

            //humidity tooltip error
            humidityTooltipErrorSES0: "--",
            humidityTooltipErrorSES1: "--",
            humidityTooltipErrorSES2: "--",
            humidityTooltipErrorMES2: "--",
            humidityTooltipErrorMES1: "--",
            humidityTooltipErrorMESPlus: "--",
            humidityTooltipErrorMES0: "--",
            humidityTooltipErrorMWS0: "--",
            humidityTooltipErrorMWSPlus: "--",
            humidityTooltipErrorMWS1: "--",
            humidityTooltipErrorMWS2: "--",
            humidityTooltipErrorSWS2: "--",
            humidityTooltipErrorSWS1: "--",
            humidityTooltipErrorSWS0: "--",
            humidityTooltipErrorSEN0: "--",
            humidityTooltipErrorSEN1: "--",
            humidityTooltipErrorSEN2: "--",
            humidityTooltipErrorMEN2: "--",
            humidityTooltipErrorMEN1: "--",
            humidityTooltipErrorMEN0: "--",
            humidityTooltipErrorMWN0: "--",
            humidityTooltipErrorMWN1: "--",
            humidityTooltipErrorMWN2: "--",
            humidityTooltipErrorSWN2: "--",
            humidityTooltipErrorSWN1: "--",
            humidityTooltipErrorSWN0: "--",

            dataNameIdDict: {
                //humidity, temperature
                humiditySES0: "GUID",
                humiditySES1: "GUID",
                humiditySES2: "GUID",
                humidityMES2: "GUID",
                humidityMES1: "GUID",
                humidityMESPlus: "GUID",
                humidityMES0: "GUID",
                humidityMWS0: "GUID",
                humidityMWSPlus: "GUID",
                humidityMWS1: "GUID",
                humidityMWS2: "GUID",
                humiditySWS2: "GUID",
                humiditySWS1: "GUID",
                humiditySWS0: "GUID",
                humiditySEN0: "GUID",
                humiditySEN1: "GUID",
                humiditySEN2: "GUID",
                humidityMEN2: "GUID",
                humidityMEN1: "GUID",
                humidityMEN0: "GUID",
                humidityMWN0: "GUID",
                humidityMWN1: "GUID",
                humidityMWN2: "GUID",
                humiditySWN2: "GUID",
                humiditySWN1: "GUID",
                humiditySWN0: "GUID",

                temperatureSES0: "GUID",
                temperatureSES1: "GUID",
                temperatureSES2: "GUID",
                temperatureMES2: "GUID",
                temperatureMES1: "GUID",
                temperatureMESPlus: "GUID",
                temperatureMES0: "GUID",
                temperatureMWS0: "GUID",
                temperatureMWSPlus: "GUID",
                temperatureMWS1: "GUID",
                temperatureMWS2: "GUID",
                temperatureSWS2: "GUID",
                temperatureSWS1: "GUID",
                temperatureSWS0: "GUID",
                temperatureSEN0: "GUID",
                temperatureSEN1: "GUID",
                temperatureSEN2: "GUID",
                temperatureMEN2: "GUID",
                temperatureMEN1: "GUID",
                temperatureMEN0: "GUID",
                temperatureMWN0: "GUID",
                temperatureMWN1: "GUID",
                temperatureMWN2: "GUID",
                temperatureSWN2: "GUID",
                temperatureSWN1: "GUID",
                temperatureSWN0: "GUID",

                pressureSES0: "GUID",
                pressureSES1: "GUID",
                pressureSES2: "GUID",
                pressureMES2: "GUID",
                pressureMES1: "GUID",
                pressureMESPlus: "GUID",
                pressureMES0: "GUID",
                pressureMWS0: "GUID",
                pressureMWSPlus: "GUID",
                pressureMWS1: "GUID",
                pressureMWS2: "GUID",
                pressureSWS2: "GUID",
                pressureSWS1: "GUID",
                pressureSWS0: "GUID",
                pressureSEN0: "GUID",
                pressureSEN1: "GUID",
                pressureSEN2: "GUID",
                pressureMEN2: "GUID",
                pressureMEN1: "GUID",
                pressureMEN0: "GUID",
                pressureMWN0: "GUID",
                pressureMWN1: "GUID",
                pressureMWN2: "GUID",
                pressureSWN2: "GUID",
                pressureSWN1: "GUID",
                pressureSWN0: "GUID",

                //running

                //malfunction
            },

            //humidity allowed max -> id
            allowedMaxNameIdDict: {
                humidityAllowedMaxSES0: "GUID",
                humidityAllowedMaxSES1: "GUID",
                humidityAllowedMaxSES2: "GUID",
                humidityAllowedMaxMES2: "GUID",
                humidityAllowedMaxMES1: "GUID",
                humidityAllowedMaxMESPlus: "GUID",
                humidityAllowedMaxMES0: "GUID",
                humidityAllowedMaxMWS0: "GUID",
                humidityAllowedMaxMWSPlus: "GUID",
                humidityAllowedMaxMWS1: "GUID",
                humidityAllowedMaxMWS2: "GUID",
                humidityAllowedMaxSWS2: "GUID",
                humidityAllowedMaxSWS1: "GUID",
                humidityAllowedMaxSWS0: "GUID",
                humidityAllowedMaxSEN0: "GUID",
                humidityAllowedMaxSEN1: "GUID",
                humidityAllowedMaxSEN2: "GUID",
                humidityAllowedMaxMEN2: "GUID",
                humidityAllowedMaxMEN1: "GUID",
                humidityAllowedMaxMEN0: "GUID",
                humidityAllowedMaxMWN0: "GUID",
                humidityAllowedMaxMWN1: "GUID",
                humidityAllowedMaxMWN2: "GUID",
                humidityAllowedMaxSWN2: "GUID",
                humidityAllowedMaxSWN1: "GUID",
                humidityAllowedMaxSWN0: "GUID",
            },

            //humidity, temperature -> error
            dataNameErrorNameDict: {

                humiditySES0: "errorSES0",
                humiditySES1: "errorSES1",
                humiditySES2: "errorSES2",
                humidityMES2: "errorMES2",
                humidityMES1: "errorMES1",
                humidityMESPlus: "errorMESPlus",
                humidityMES0: "errorMES0",
                humidityMWS0: "errorMWS0",
                humidityMWSPlus: "errorMWSPlus",
                humidityMWS1: "errorMWS1",
                humidityMWS2: "errorMWS2",
                humiditySWS2: "errorSWS2",
                humiditySWS1: "errorSWS1",
                humiditySWS0: "errorSWS0",
                humiditySEN0: "errorSEN0",
                humiditySEN1: "errorSEN1",
                humiditySEN2: "errorSEN2",
                humidityMEN2: "errorMEN2",
                humidityMEN1: "errorMEN1",
                humidityMEN0: "errorMEN0",
                humidityMWN0: "errorMWN0",
                humidityMWN1: "errorMWN1",
                humidityMWN2: "errorMWN2",
                humiditySWN2: "errorSWN2",
                humiditySWN1: "errorSWN1",
                humiditySWN0: "errorSWN0",

                temperaturerSES0: "errorSES0",
                temperaturerSES1: "errorSES1",
                temperaturerSES2: "errorSES2",
                temperaturerMES2: "errorMES2",
                temperaturerMES1: "errorMES1",
                temperaturerMESPlus: "errorMESPlus",
                temperaturerMES0: "errorMES0",
                temperaturerMWS0: "errorMWS0",
                temperaturerMWSPlus: "errorMWSPlus",
                temperaturerMWS1: "errorMWS1",
                temperaturerMWS2: "errorMWS2",
                temperaturerSWS2: "errorSWS2",
                temperaturerSWS1: "errorSWS1",
                temperaturerSWS0: "errorSWS0",
                temperaturerSEN0: "errorSEN0",
                temperaturerSEN1: "errorSEN1",
                temperaturerSEN2: "errorSEN2",
                temperaturerMEN2: "errorMEN2",
                temperaturerMEN1: "errorMEN1",
                temperaturerMEN0: "errorMEN0",
                temperaturerMWN0: "errorMWN0",
                temperaturerMWN1: "errorMWN1",
                temperaturerMWN2: "errorMWN2",
                temperaturerSWN2: "errorSWN2",
                temperaturerSWN1: "errorSWN1",
                temperaturerSWN0: "errorSWN0",

                pressureSES0: "errorSES0",
                pressureSES1: "errorSES1",
                pressureSES2: "errorSES2",
                pressureMES2: "errorMES2",
                pressureMES1: "errorMES1",
                pressureMESPlus: "errorMESPlus",
                pressureMES0: "errorMES0",
                pressureMWS0: "errorMWS0",
                pressureMWSPlus: "errorMWSPlus",
                pressureMWS1: "errorMWS1",
                pressureMWS2: "errorMWS2",
                pressureSWS2: "errorSWS2",
                pressureSWS1: "errorSWS1",
                pressureSWS0: "errorSWS0",
                pressureSEN0: "errorSEN0",
                pressureSEN1: "errorSEN1",
                pressureSEN2: "errorSEN2",
                pressureMEN2: "errorMEN2",
                pressureMEN1: "errorMEN1",
                pressureMEN0: "errorMEN0",
                pressureMWN0: "errorMWN0",
                pressureMWN1: "errorMWN1",
                pressureMWN2: "errorMWN2",
                pressureSWN2: "errorSWN2",
                pressureSWN1: "errorSWN1",
                pressureSWN0: "errorSWN0",
            },

            //malfunction -> error
            malfunctionDataNameErrorNameDict: {
            },

            //humidity -> humidity tooltip error
            dataNameTooltipErrorNameDict: {
                humiditySES0: "humidityTooltipErrorSES0",
                humiditySES1: "humidityTooltipErrorSES1",
                humiditySES2: "humidityTooltipErrorSES2",
                humidityMES2: "humidityTooltipErrorMES2",
                humidityMES1: "humidityTooltipErrorMES1",
                humidityMESPlus: "humidityTooltipErrorMESPlus",
                humidityMES0: "humidityTooltipErrorMES0",
                humidityMWS0: "humidityTooltipErrorMWS0",
                humidityMWSPlus: "humidityTooltipErrorMWSPlus",
                humidityMWS1: "humidityTooltipErrorMWS1",
                humidityMWS2: "humidityTooltipErrorMWS2",
                humiditySWS2: "humidityTooltipErrorSWS2",
                humiditySWS1: "humidityTooltipErrorSWS1",
                humiditySWS0: "humidityTooltipErrorSWS0",
                humiditySEN0: "humidityTooltipErrorSEN0",
                humiditySEN1: "humidityTooltipErrorSEN1",
                humiditySEN2: "humidityTooltipErrorSEN2",
                humidityMEN2: "humidityTooltipErrorMEN2",
                humidityMEN1: "humidityTooltipErrorMEN1",
                humidityMEN0: "humidityTooltipErrorMEN0",
                humidityMWN0: "humidityTooltipErrorMWN0",
                humidityMWN1: "humidityTooltipErrorMWN1",
                humidityMWN2: "humidityTooltipErrorMWN2",
                humiditySWN2: "humidityTooltipErrorSWN2",
                humiditySWN1: "humidityTooltipErrorSWN1",
                humiditySWN0: "humidityTooltipErrorSWN0",
            },

            //running -> running class
            dataNameRunningClassNameDict: {

            },

            //station id list
            stationIdList: [
                "2860c03a-1dc5-4ba5-bd74-7b209ef6c4c6",
            ],
        };
    },
    filters: {
        toFixed(val) {
            if (val === 0) return "0.0";
            if (!Number(val)) return "--";
            return Number(val).toFixed(1);
        },
    },
    mounted() {
        this.getAllowedMax();
        this.getData();
        this.timer = setInterval(() => {
            this.getData();
        }, this.REFRESH_SECOND);
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {
        refreshData() {
            this.loading = true;
            this.getData();
        },
        getData() {
            this.resetError();
            let stationRequestList = [];
            this.stationIdList.forEach((stationId) => {
                stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
            });

            this.$http.all(stationRequestList).then(
                this.$http.spread((...resList) => {
                    resList.forEach((res) => {
                        this.setDataAndError(res.data);
                        this.loading = false;
                    });
                })
            );
        },
        setDataAndError(stationData) {
            //device id not set (device id = 'GUID') = no data
            stationData["GUID"] = {
                dataId: null,
                deviceId: "GUID",
                value: null,
                createdDate: "0001-01-01T00:00:00",
                dataDate: "0001-01-01T00:00:00",
                dataType: "VALUE",
                errorLevel: "Warning",
            };

            for (let dataName in this.dataNameIdDict) {
                const dataId = this.dataNameIdDict[dataName];
                if (stationData[dataId] !== undefined) {
                    this[dataName] = stationData[dataId].value;

                    // //set value for running sign
                    // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
                    //   let runningData = stationData[dataId];
                    //   if (runningData.value === 1) {
                    //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
                    //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
                    //   } else if (runningData.errorLevel !== "Warning") {
                    //     //empty data value also === 0
                    //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
                    //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
                    //   }
                    // }

                    //set value for running sign
                    if (this.dataNameRunningClassNameDict[dataName] != undefined) {
                        let runningData = stationData[dataId];
                        if (runningData.value === 1) {
                            this[this.dataNameRunningClassNameDict[dataName]] = "running";
                        } else if (runningData.errorLevel !== "Warning") {
                            //empty data value also === 0
                            this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
                        }
                    }

                    if (this.dataNameErrorNameDict[dataName] !== undefined) {
                        const errorName = this.dataNameErrorNameDict[dataName];
                        this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
                    }

                    if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
                        const errorName = this.dataNameTooltipErrorNameDict[dataName];
                        this[errorName] = stationData[dataId].errorLevel;
                    }

                    if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
                        const errorName = this.malfunctionDataNameErrorNameDict[dataName];
                        if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
                            this[errorName] = "Error";
                        }
                    }
                }
            }
        },
        getAllowedMax() {
            let stationMetaRequestList = [];
            this.stationIdList.forEach((stationId) => {
                stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
            });

            this.$http.all(stationMetaRequestList).then(
                this.$http.spread((...resList) => {
                    resList.forEach((res) => {
                        this.setAllowedMax(res.data);
                    });
                })
            );
        },
        setAllowedMax(stationData) {
            let deviceIdDevicedict = {};
            if (stationData.deviceList) {
                stationData.deviceList.forEach((item) => {
                    deviceIdDevicedict[item.deviceId] = item;
                });
            }

            for (let allowedMaxName in this.allowedMaxNameIdDict) {
                const dataId = this.allowedMaxNameIdDict[allowedMaxName];
                if (deviceIdDevicedict[dataId] !== undefined) {
                    let device = deviceIdDevicedict[dataId];
                    this[allowedMaxName] = device.allowedMax;
                }
            }
        },
        getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
            if (currentErrorLevel === "Error") {
                return "Error";
            } else if (currentErrorLevel === "Warning") {
                if (newErrorLevel === "Error") {
                    return "Error";
                } else {
                    return "Warning";
                }
            } else {
                return newErrorLevel;
            }
        },
        resetError() {
            for (let dataName in this.dataNameIdDict) {
                if (this.dataNameErrorNameDict[dataName] !== undefined) {
                    const errorName = this.dataNameErrorNameDict[dataName];
                    this[errorName] = "";
                }

                if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
                    const errorName = this.dataNameTooltipErrorNameDict[dataName];
                    this[errorName] = "";
                }
            }
        },
        assembleTooltip_sensor(name, errorLevel, allowedMax) {
            let result = "";
            if (name) {
                result += name + ": ";
            }

            if (errorLevel.toLowerCase() === "normal") {
                result += "湿度正常";
            } else if (errorLevel.toLowerCase() === "warning") {
                result += "数据中断";
            } else if (errorLevel.toLowerCase() === "error") {
                result += "湿度超限";
            }

            if (
                (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
                allowedMax !== undefined &&
                allowedMax !== null &&
                !isNaN(parseInt(allowedMax))
            ) {
                if (allowedMax === 0) {
                    result += "(无限制)";
                } else {
                    result += "(<" + allowedMax + "%RH)";
                }
            }

            return result;
        },
        assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
            let result = "";
            if (name) {
                result += name + ": ";
            }

            if (errorLevel.toLowerCase() === "normal") {
                result += "湿度正常";
            } else if (errorLevel.toLowerCase() === "warning") {
                result += "数据中断";
            } else if (errorLevel.toLowerCase() === "error") {
                result += "湿度超限";
            }

            if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
                result += "(<" + allowedMax + "%RH)";
            }

            if (errorLevel === "" && allowedMax === "") {
                //no humidity dehumidifier
                // console.log('running flag: ' + runningFlag + ", error flag: " + errorFlag);
                if (runningFlag === null || errorFlag === null) {
                    result += "数据中断";
                }

                if (runningFlag > 0) {
                    result += " 除湿机运行";
                } else if (runningFlag === 0) {
                    result += " 除湿机停止";
                }

                if (errorFlag > 0) {
                    result += "  故障报警";
                }
            }
            else {
                //normal dehumidifier
                if (errorLevel.toLowerCase() !== "warning") {
                    if (runningFlag > 0) {
                        result += ", 除湿机运行";
                    } else if (runningFlag === 0) {
                        result += ", 除湿机停止";
                    }
                }

                if (errorFlag > 0) {
                    result += ", 故障报警";
                }
            }

            return result;
        },
    },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
    0% {
        border-color: rgba(255, 255, 0, 0.3);
    }

    100% {
        border-color: #ffff00;
        // background: rgba(255, 255, 255, 0.7);
    }
}

@keyframes breathee-error {
    0% {
        border-color: rgba(255, 0, 0, 0.3);
    }

    100% {
        border-color: #ff0000;
        // background: rgba(255, 255, 255, 0.7);
    }
}

.tooltip-slot {
    line-height: 1.4;
}

.gas-clamp {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: calc(100% - 20px) !important;
    // min-height: 630px !important;

    .main-cable {
        width: 100%;
        height: 48%;
        padding: 0;
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        min-height: 370px;

        .cable-title {
            width: 50px;
            text-align: center;
            display: flex;
            background-color: #fff;
            justify-content: center;
            align-items: center;

            h2 {
                padding: 0 10px;
                font-weight: bold;
                font-size: 32px;
                line-height: 35px;
                color: #515151;
            }
        }

        .cable-main {
            position: relative;
            min-width: 1350px;
            width: calc(100% - 50px);
            background: linear-gradient(#ceeaf0, #e9f1ef);
            display: flex;
            justify-content: center;
            align-items: center;

            .legend {
                position: absolute;
                left: 75px;
                top: 50px;

                div {
                    padding-left: 30px;
                    height: 20px;
                    margin-bottom: 10px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #515151;
                    position: relative;

                    &:after {
                        position: absolute;
                        left: 0;
                        top: 0;
                        content: " ";
                        overflow: hidden;
                        display: block;
                        height: 20px;
                        width: 20px;
                        border-radius: 10px;
                    }
                }

                .sensor1:after {
                    background: #c7798b;
                }

                .sensor2:after {
                    background: #3376c7;
                }
            }

            .legend-right {
                position: absolute;
                right: 70px;
                top: 50px;

                div {
                    padding-left: 30px;
                    height: 20px;
                    margin-bottom: 10px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #515151;
                    position: relative;

                    &:after {
                        position: absolute;
                        left: 0;
                        top: 0;
                        content: " ";
                        overflow: hidden;
                        display: block;
                        height: 20px;
                        width: 20px;
                        border-radius: 10px;
                    }
                }

                .default:after {
                    background: #ffff00;
                }

                .running:after {
                    background: #67dd34;
                }

                .stopped:after {
                    background: #a0a0a0;
                }
            }

            .legend-station {
                position: absolute;
                left: 73px;
                top: 108px;

                i {
                    font-size: 24px;
                    color: #ed6a5a;
                }

                span {
                    padding-left: 8px;
                    bottom: 3px;
                    margin-bottom: 10px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #515151;
                    position: relative;
                }
            }

            .dir {
                position: absolute;
                top: 50px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #2a387a;

                i {
                    font-size: 30px;
                }

                .dir-text {
                    font-size: 20px;
                }
            }

            .left-dir {
                left: 185px;
            }

            .right-dir {
                flex-direction: row-reverse;
                right: 185px;
            }

            .cable-img {
                position: relative;
                z-index: 0;
                width: 1200px;
                height: 300px;
                background-position: 50%;
                background-repeat: no-repeat;
                background-size: contain;
                background-image: url("../../assets/image/beipanjiang/bridgeLine.png");
                background-position-y: 100%;

                .station-block {
                    position: absolute;
                    color: #ed6a5a;
                    font-size: 24px;
                    text-decoration: none;
                }

                .stati {
                    position: absolute;

                    &:before,
                    &:after {
                        position: absolute;
                        display: block;
                        content: "";
                        height: 2px;
                        background: #ed6a5a;
                    }

                    &:before {
                        width: 50px;
                    }

                    &:after {
                        width: 15px;
                    }

                    .state-info {
                        font-size: 14px;
                        line-height: 17px;
                        color: #515151;
                        text-align: right;
                        min-width: 75px;
                        transform: translateY(-50%);
                        position: absolute;
                        text-decoration: none;
                        border-radius: 10px;
                        box-sizing: border-box;
                        padding: 6px 8px 6px 6px;
                        border: 2px solid transparent;
                        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
                        background-color: rgba(246, 250, 255, 0.9);

                        &:before {
                            background-color: #ed6a5a;
                        }

                        &>p {
                            margin: 0;
                            white-space: nowrap;
                            white-space: nowrap;
                            display: flex;
                            justify-content: space-between;
                            align-items: baseline;

                            &:first-child {
                                font-size: 13px;
                            }
                        }

                        &.right-pos:before {
                            right: 0;
                            transform: translate(50%, -50%);
                        }

                        &.left-pos:before {
                            left: -8px;
                            transform: translate(50%, -50%);
                        }

                        &.bottom-pos:before {
                            left: 50%;
                            top: 95%;
                            transform: translate(0%, 0%);
                        }

                        &.top-pos:before {
                            left: 50%;
                            top: -3px;
                            transform: translate(0%, 0%);
                        }

                        &.bottom-pos-sta:before {
                            left: 50%;
                            top: 95%;
                            transform: translate(0%, 0%);
                        }

                        &:before {
                            position: absolute;
                            display: block;
                            content: "";
                            height: 8px;
                            width: 8px;
                            border-radius: 4px;
                            top: 50%;
                        }

                        .bold {
                            font-weight: 800;
                        }

                        .valve-sign {
                            margin-top: auto;
                            margin-bottom: auto;
                            width: 12px;
                            height: 12px;
                            background-color: #ffff00;
                            animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
                            border-radius: 10px;
                            margin-left: 15px;

                            &.running {
                                background-color: #67dd34;
                                animation: none;
                            }

                            &.stopped {
                                background-color: #a0a0a0;
                                animation: none;
                            }
                        }
                    }

                    .Warning {
                        border-color: #ffff00;
                        animation: breathee-warning 1500ms infinite alternate ease-in-out;
                    }

                    .Error {
                        border-color: #ff0000;
                        animation: breathee-error 1500ms infinite alternate ease-in-out;
                    }
                }

                .clip {
                    position: absolute;
                    width: 16px;
                    height: 16px;
                    border-radius: 8px;

                    &:before,
                    &:after {
                        position: absolute;
                        display: block;
                        content: "";
                        height: 2px;
                    }

                    &:before {
                        width: 50px;
                    }

                    &:after {
                        width: 15px;
                    }

                    .state-info {
                        font-size: 14px;
                        line-height: 17px;
                        color: #515151;
                        text-align: right;
                        min-width: 75px;
                        transform: translateY(-50%);
                        position: absolute;
                        border-radius: 10px;
                        box-sizing: border-box;
                        padding: 6px 8px 6px 6px;
                        border: 2px solid transparent;
                        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

                        &>p {
                            margin: 0;
                            white-space: nowrap;

                            &:first-child {
                                font-size: 13px;
                            }
                        }

                        .bold {
                            font-weight: 800;
                        }

                        &.right-pos:before {
                            right: 0;
                            transform: translate(50%, -50%);
                        }

                        &.left-pos:before {
                            left: -8px;
                            transform: translate(50%, -50%);
                        }

                        &.bottom-pos:before {
                            left: 50%;
                            top: 95%;
                            transform: translate(0%, 0%);
                        }

                        &.bottom-left-pos-mid:before {
                            left: 47.5%;
                            top: 95%;
                            transform: translate(0%, 0%);
                        }

                        &.top-pos:before {
                            left: 46%;
                            top: -5%;
                            transform: translate(0%, 0%);
                        }

                        &.top-left-pos-1:before {
                            left: 20%;
                            top: -5%;
                            transform: translate(0%, 0%);
                        }

                        &.top-right-pos-1:before {
                            left: 80%;
                            top: -5%;
                            transform: translate(0%, 0%);
                        }

                        &.top-right-pos-mid:before {
                            left: 52.5%;
                            top: -5%;
                            transform: translate(0%, 0%);
                        }

                        &:before {
                            position: absolute;
                            display: block;
                            content: "";
                            height: 8px;
                            width: 8px;
                            border-radius: 4px;
                            top: 50%;
                        }
                    }

                    .Warning {
                        border-color: #ffff00;
                        animation: breathee-warning 1500ms infinite alternate ease-in-out;
                    }

                    .Error {
                        border-color: #ff0000;
                        animation: breathee-error 1500ms infinite alternate ease-in-out;
                    }

                    &.sensor1 {
                        background: #c7798b;

                        &:after,
                        &:before {
                            background: #c7798b;
                        }

                        .state-info {
                            background-color: rgba(246, 250, 255, 0.9);

                            &:before {
                                background-color: #c7798b;
                            }
                        }
                    }

                    &.sensor2 {
                        background: #3376c7;

                        &:after,
                        &:before {
                            background: #3376c7;
                        }

                        .state-info {
                            background-color: rgba(246, 250, 255, 0.9);

                            &:before {
                                background-color: #3376c7;
                            }
                        }
                    }
                }

                .station-block-left {
                    top: 95px;
                    left: 230px;
                }

                .station-block-middle {
                    top: 165px;
                    left: 590px;
                }

                .station-block-right {
                    top: 93px;
                    left: 953px;
                }

                .sta-left {
                    top: 108px;
                    left: 282px;

                    &::before {
                        bottom: 20px;
                        left: -65px;
                        width: 50px;
                        transform: rotate(90deg);
                    }

                    &::after {
                        bottom: -49px;
                        left: -17px;
                        width: 0;
                    }

                    .state-info {
                        right: -35px;
                        top: -65px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sta-middle {
                    top: 188px;
                    left: 640px;

                    &::before {
                        bottom: 75px;
                        left: -105px;
                        width: 130px;
                        transform: rotate(90deg);
                    }

                    &::after {
                        bottom: -49px;
                        left: -17px;
                        width: 0;
                    }

                    .state-info {
                        right: -29px;
                        top: -150px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sta-right {
                    top: 108px;
                    left: 1005px;

                    &::before {
                        bottom: 25px;
                        left: -60px;
                        width: 40px;
                        transform: rotate(90deg);
                    }

                    &::after {
                        bottom: -49px;
                        left: -17px;
                        width: 0;
                    }

                    .state-info {
                        right: -42px;
                        top: -65px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sensor-left-1 {
                    top: 161px;
                    left: 110px;

                    &::before {
                        bottom: 22px;
                        left: -16px;
                        width: 40px;
                        transform: rotate(75deg);
                    }

                    &::after {
                        bottom: 41px;
                        left: -16px;
                    }

                    .state-info {
                        right: 28px;
                        top: -26px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sensor-left-2 {
                    top: 130px;
                    left: 190px;

                    &::before {
                        bottom: -27px;
                        left: -30px;
                        width: 75px;
                        transform: rotate(270deg);
                    }

                    &::after {
                        bottom: -54px;
                        left: 14px;
                        width: 0px;
                    }

                    .state-info {
                        right: -15px;
                        top: 112px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sensor-left-3 {
                    top: 100px;
                    left: 272px;

                    &::before {
                        bottom: 22px;
                        left: -20px;
                        width: 40px;
                        transform: rotate(60deg);
                    }

                    &::after {
                        bottom: 39px;
                        left: -24px;
                    }

                    .state-info {
                        right: 35px;
                        top: -23px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }


                .sensor-middle-left-1-no-plus {
                    top: 100px;
                    left: 293px;

                    &::before {
                        bottom: 22px;
                        left: -4px;
                        width: 40px;
                        transform: rotate(120deg);
                    }

                    &::after {
                        bottom: 39px;
                        left: 25px;
                    }

                    .state-info {
                        right: -155px;
                        top: -23px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sensor-middle-left-1 {
                    top: 100px;
                    left: 293px;

                    &::before {
                        bottom: 44px;
                        left: -21px;
                        width: 80px;
                        transform: rotate(105deg);
                    }

                    &::after {
                        bottom: 82px;
                        left: 29px;
                    }

                    .state-info {
                        right: -155px;
                        top: -66px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }


                .sensor-middle-left-2 {
                    top: 140px;
                    left: 444px;

                    &::before {
                        bottom: -27px;
                        left: -25px;
                        width: 65px;
                        transform: rotate(270deg);
                    }

                    &::after {
                        bottom: -54px;
                        left: 14px;
                        width: 0px;
                    }

                    .state-info {
                        right: -15px;
                        top: 102px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }


                .sensor-middle-left-3 {
                    top: 150px;
                    left: 518px;

                    &::before {
                        bottom: 15px;
                        left: -5px;
                        width: 25px;
                        transform: rotate(90deg);
                    }

                    &::after {
                        bottom: -49px;
                        left: -17px;
                        width: 0;
                    }

                    .state-info {
                        right: -50px;
                        top: -45px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 125px;
                    }
                }

                .sensor-middle-up-no-plus {
                    top: 150px;
                    left: 580px;

                    &::before {
                        bottom: 30px;
                        left: -20px;
                        width: 55px;
                        transform: rotate(90deg);
                    }

                    &::after {
                        bottom: -49px;
                        left: -17px;
                        width: 0;
                    }

                    .state-info {
                        right: -56px;
                        top: -74px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sensor-middle-up {
                    top: 150px;
                    left: 580px;

                    &::before {
                        bottom: 52px;
                        left: -42px;
                        width: 100px;
                        transform: rotate(90deg);
                    }

                    &::after {
                        bottom: -49px;
                        left: -17px;
                        width: 0;
                    }

                    .state-info {
                        right: -56px;
                        top: -120px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sensor-middle-down {
                    top: 150px;
                    left: 590px;

                    &::before {
                        bottom: -20px;
                        left: -15px;
                        width: 45px;
                        transform: rotate(270deg);
                    }

                    &::after {
                        bottom: -49px;
                        left: -17px;
                        width: 0;
                    }

                    .state-info {
                        right: -49px;
                        top: 92px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sensor-middle-right-3 {
                    top: 150px;
                    left: 652px;

                    &::before {
                        bottom: 15px;
                        left: -5px;
                        width: 25px;
                        transform: rotate(90deg);
                    }

                    &::after {
                        bottom: -49px;
                        left: -17px;
                        width: 0;
                    }

                    .state-info {
                        right: -50px;
                        top: -45px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 125px;
                    }
                }

                .sensor-middle-right-2 {
                    top: 140px;
                    left: 726px;

                    &::before {
                        bottom: -27px;
                        left: -25px;
                        width: 65px;
                        transform: rotate(270deg);
                    }

                    &::after {
                        bottom: -54px;
                        left: 14px;
                        width: 0px;
                    }

                    .state-info {
                        right: -90px;
                        top: 102px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sensor-middle-right-1-no-plus {
                    top: 100px;
                    left: 880px;

                    &::before {
                        bottom: 22px;
                        left: -20px;
                        width: 40px;
                        transform: rotate(60deg);
                    }

                    &::after {
                        bottom: 39px;
                        left: -24px;
                    }

                    .state-info {
                        right: 40px;
                        top: -23px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sensor-middle-right-1 {
                    top: 100px;
                    left: 880px;

                    &::before {
                        bottom: 44px;
                        left: -42px;
                        width: 80px;
                        transform: rotate(75deg);
                    }

                    &::after {
                        bottom: 82px;
                        left: -27px;
                    }

                    .state-info {
                        right: 40px;
                        top: -66px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sensor-right-3 {
                    top: 100px;
                    left: 898px;

                    &::before {
                        bottom: 22px;
                        left: -5px;
                        width: 40px;
                        transform: rotate(120deg);
                    }

                    &::after {
                        bottom: 39px;
                        left: 24px;
                    }

                    .state-info {
                        right: -148px;
                        top: -23px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sensor-right-2 {
                    top: 130px;
                    left: 980px;

                    &::before {
                        bottom: -27px;
                        left: -30px;
                        width: 75px;
                        transform: rotate(270deg);
                    }

                    &::after {
                        bottom: -54px;
                        left: 14px;
                        width: 0px;
                    }

                    .state-info {
                        right: -91px;
                        top: 112px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }

                .sensor-right-1 {
                    top: 161px;
                    left: 1060px;

                    &::before {
                        bottom: 22px;
                        left: -8px;
                        width: 40px;
                        transform: rotate(105deg);
                    }

                    &::after {
                        bottom: 41px;
                        left: 16px;
                    }

                    .state-info {
                        right: -142px;
                        top: -26px;
                        // 在数据为空时维持宽度, 以免断连
                        min-width: 130px;
                    }
                }
            }
        }
    }
}
</style>